/* eslint-disable import/no-mutable-exports */
import httpClient from './http-client';
import mockMessageService from './message.service.mock';

let messageService;

if (process.env.NODE_ENV === 'development') {
  messageService = mockMessageService;
} else {
  messageService = {
    // params: subject, type, status, sender, termStart, termEnd, orderBy, page, pageSize
    getList(params) {
      return httpClient.get('/message', { params });
    },

    markAsRead(messageIds) {
      const body = {
        message: messageIds,
      };
      return httpClient.put('/message', body);
    },

    delete(messageIds) {
      const body = {
        message: messageIds,
      };
      return httpClient.delete('/message', { data: body });
    },

    getById(id, params) {
      return httpClient.get(`/message/${id}`, { params });
    },

    getAttachment(messageId, attachmentId) {
      const params = {
        messageId,
        attachmentId,
      };

      return httpClient({
        url: '/message/attachment',
        method: 'GET',
        responseType: 'blob',
        params,
      });
    },

    getProfileAttachment(messageId, attachmentId) {
      const params = {
        messageId,
        attachmentId,
      };

      return httpClient({
        url: '/message/profileAttachment',
        method: 'GET',
        responseType: 'blob',
        params,
      });
    },

    createAttachment(messageId, file) {
      const body = new FormData();
      body.append('file', file);
      const params = {
        messageId,
      };
      return httpClient.post('/message/attachment', body, { params });
    },

    deleteAttachment(messageId, attachmentId) {
      const params = {
        messageId,
        attachmentId,
      };
      return httpClient.delete('/message/attachment', { params });
    },

    // params: subject, type, sender, recipient, orderBy, page, pageSize
    getDraftList(params) {
      return httpClient.get('/message/draft', { params });
    },

    deleteDraft(messageIds) {
      return httpClient.delete('/message/draft', {
        data: {
          messageId: messageIds,
        },
      });
    },

    getDraft(id) {
      return httpClient.get(`/message/draft/${id}`);
    },

    initDraft() {
      return httpClient.post('/message/draftInit');
    },

    saveDraft(message) {
      const requestBody = JSON.parse(JSON.stringify(message));
      if (requestBody.recipient?.userGroup?.length) {
        for (let i = 0; i < requestBody.recipient.userGroup.length; i += 1) {
          delete requestBody.recipient.userGroup[i].description;
        }
      }
      return httpClient.put('/message/draftSave', requestBody);
    },

    sendDraft(message) {
      return httpClient.post('/message/draftSend', message);
    },

    getImportantList() {
      const params = {
        type: 'I',
        status: 'UNREAD',
        page: 1,
      };
      return httpClient.get('/message', { params });
    },

    // params: subject, type, sender, recipient, orderBy, page, pageSize
    getOutboxList(params) {
      return httpClient.get('/message/outbox', { params });
    },
  };
}

export default messageService;
